import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import SocialLinks from './SocialLinks';
import { COMPANY, CONTACT_PATH, LEGAL_PATHS, OFFERING_PATH } from '../legal/company';

const PRODUCT_LINKS = [
  { label: 'Features', href: '/#features' },
  { label: 'Pricing', href: '/#pricing' },
  { label: 'What you get', href: OFFERING_PATH },
  { label: 'FAQ', href: '/#faq' },
];

const LEGAL_LINKS = [
  { label: 'Terms & Conditions', href: LEGAL_PATHS.terms },
  { label: 'Privacy Policy', href: LEGAL_PATHS.privacy },
  { label: 'Cookie Policy', href: LEGAL_PATHS.cookies },
  { label: 'Refund & Cancellation Policy', href: LEGAL_PATHS.refunds },
];

const SiteFooter: React.FC = () => (
  <footer className="nova-footer px-6 lg:px-12">
    <div className="max-w-content mx-auto">
      <div className="grid md:grid-cols-4 gap-10 mb-12">
        <div className="md:col-span-1">
          <Link to="/" aria-label="OnTheWeb home">
            <Logo size="sm" />
          </Link>
          <p className="text-nova-text2 text-sm mt-4 leading-relaxed">
            Build beautiful websites with the power of AI. No coding required.
          </p>
          <SocialLinks />
        </div>
        <div>
          <h4 className="font-display font-semibold text-nova-text mb-4">Product</h4>
          <ul className="space-y-2">
            {PRODUCT_LINKS.map((link) => (
              <li key={link.href}>
                <Link to={link.href} className="text-nova-text2 hover:text-nova-sky text-sm transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-nova-text mb-4">Legal</h4>
          <ul className="space-y-2">
            {LEGAL_LINKS.map((link) => (
              <li key={link.href}>
                <Link to={link.href} className="text-nova-text2 hover:text-nova-sky text-sm transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-nova-text mb-4">Contact</h4>
          <ul className="space-y-2 text-sm text-nova-text2">
            <li>
              <Link to={CONTACT_PATH} className="hover:text-nova-sky transition-colors">
                Contact us
              </Link>
            </li>
            <li>
              <a href={`mailto:${COMPANY.supportEmail}`} className="hover:text-nova-sky transition-colors">
                {COMPANY.supportEmail}
              </a>
            </li>
            <li>
              <a href={COMPANY.phoneHref} className="hover:text-nova-sky transition-colors">
                {COMPANY.phone}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-nova-border pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-nova-text3 text-sm text-center md:text-left">
          © {new Date().getFullYear()} {COMPANY.legalName}. All rights reserved. CIN {COMPANY.cin}.
        </p>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
